fragment FeaturesWithIconsFragment on featuresWithIcons_Entry {
  typeHandle
  heading
  featureItems: features {
    ... on featuresBlock_Entry {
      id
      heading
      description
      icon {
        alt
        url
      }
    }
  }
}
